import { render, staticRenderFns } from "./post_voter_vote.vue?vue&type=template&id=088d6d88&scoped=true&"
import script from "./post_voter_vote.vue?vue&type=script&lang=js&"
export * from "./post_voter_vote.vue?vue&type=script&lang=js&"
import style0 from "./post_voter_vote.vue?vue&type=style&index=0&id=088d6d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d6d88",
  null
  
)

export default component.exports